import React, { createContext, useContext, useState } from "react";
import { doc, getDoc} from "firebase/firestore";
import { auth, db } from "../../../Admin/Config/Config";

const RelatedProductsContext = createContext();

export const RelatedProductsProvider = ({ children }) => {
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [load, setLoad] = useState(false);

  const fetchRelatedProductsByIds = async (relatedProductIds) => {
    setLoad(true);
    const productsList = [];
    let userDetails = {};
    if (auth.currentUser) {
      const userRef = doc(db, "users", auth.currentUser.uid);
      const userDoc = await getDoc(userRef);
      if (userDoc.exists()) {
        userDetails = userDoc.data();
      }
    }
    try {
      for (const id of relatedProductIds) {
        let offer_price = 0;
        let original_price = 0;
        if (userDetails && userDetails.schemeId) {
          const priceRef = doc(
            db,
            "product_price",
            userDetails?.schemeId,
            "products",
            id.id
          );
          const priceSnap = await getDoc(priceRef);
          offer_price = priceSnap.exists() ? priceSnap.data().offer_price : 0;
          original_price = priceSnap.exists()
            ? priceSnap.data().original_price
            : 0;
        }
        const productDoc = await getDoc(doc(db, "products", id.id));
        if (productDoc.exists()) {
          productsList.push({
            id: productDoc.id,
            ...productDoc.data(),
            offer_price: offer_price||0,
            original_price: original_price||0
          });
        }
      }
      setRelatedProducts(productsList);
    } catch (error) {
      console.error("Error fetching related products:", error);
    } finally {
      setLoad(false);
    }
  };
  return (
    <RelatedProductsContext.Provider
      value={{ relatedProducts, load, fetchRelatedProductsByIds }}
    >
      {children}
    </RelatedProductsContext.Provider>
  );
};

export const useRelatedProducts = () => useContext(RelatedProductsContext);

